export class ModalConfig {
    animated:boolean = true;
    title:string = "";
    backdrop:boolean =  false;
    class:string = "";
    initialState:any = {};
    ignoreBackdropClick: boolean = false;
    keyboard: boolean = true;
}